'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = 'M319.7 60l54.8 104 115.8 20 66.9 11.6-47.3 48.7L428 328.5l16.7 116.3 9.7 67.2-60.9-29.9L288.1 430.2 182.6 482.1 121.7 512l9.7-67.2 16.7-116.3L66.2 244.2 18.9 195.6 85.7 184l115.8-20L256.4 60 288.1 0l31.7 60zM288.1 367.8l24.7 12.1 71.1 35-11.3-78.4-3.9-27.3 19.2-19.7 55.2-56.8L365 219.1l-27.1-4.7L325 190.1l-37-70.1 0 247.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;